import { z } from 'zod';
import { ExceptionType } from '../valueobject/exception-type.ts';
import { ValidatableModel } from '../../model/validatable-model.ts';

/**
 * Server Error DTO
 */
export class ServerError extends ValidatableModel {
  public static readonly schema = z.object({
    type: z.enum(ExceptionType),
    code: z.string().nullable(),
    message: z.string().nullable(),
    exceptionArguments: z.string().array(),
  });

  public static validateSingle = this.createValidator<ServerError>(this.schema);

  constructor(
    public type: ExceptionType,
    public code: string | null,
    public message: string | null,
    public exceptionArguments: string[],
  ) {
    super();
  }
}
